import { change, formValueSelector, getFormInitialValues } from "redux-form";
import { connect } from "react-redux";
import { get } from "lodash";

export function withFieldAccessors(Component) {
  return connect(
    (state, ownProps) => ({
      getFieldValue: field =>
        formValueSelector(ownProps.formName || ownProps.form)(state, field),
      getInitialFieldValue: field =>
        get(
          getFormInitialValues(ownProps.formName || ownProps.form)(state),
          field
        )
    }),
    (dispatch, ownProps) => ({
      setFieldValue: field => val =>
        dispatch(change(ownProps.formName || ownProps.form, field, val))
    })
  )(Component);
}



// WEBPACK FOOTER //
// ./app/modules/shared/decorators/withFieldAccessors.jsx